import ForgotPassword from '@pages/forgot-password/forgot-password';
export default ForgotPassword;
